// Prospect page addresses. Every prospect page has two addresses that show the same page and
// record into the same history, because the prospect's code is all that identifies the page:
//   https://go.coreestimator.com.au/<code>        the branded link prospects are sent
//   https://control-base.com.au/prospect/<code>   the original link, which keeps working permanently
// Local review builds use go.localhost, which browsers send to this computer.

export const BRANDED_HOST = 'go.coreestimator.com.au';
const LOCAL_BRANDED_HOST = 'go.localhost';

// Switch on only once go.coreestimator.com.au is live and proven (DigitalOcean domain + DNS).
// Until then Copy link and Open use the original address, which always works.
export const BRANDED_LINKS_LIVE = false;

export const CORE_ESTIMATOR_WEBSITE = 'https://www.coreestimator.com.au/';

// AppShell itself. A prospect page opened from one of these is the founder checking it.
const APPSHELL_ORIGINS = ['https://control-base.com.au', 'http://localhost:3000', 'http://127.0.0.1:3000'];

// Prospect codes are 10 lowercase hex characters (`_generate_slug` in the backend)
const CODE = /^[0-9a-f]{10}$/;

const isLocal = (hostname) => hostname === 'localhost' || hostname === '127.0.0.1';

export function isBrandedHost(hostname = window.location.hostname) {
    return hostname === BRANDED_HOST || hostname === LOCAL_BRANDED_HOST;
}

// The prospect code in a path on the branded domain, or null for any other address. Forgiving
// about what texting apps do to links: a trailing slash or full stop, capital letters, and the
// original /prospect/<code> form.
export function codeFromBrandedPath(pathname) {
    const segments = pathname.split('/').filter(Boolean);
    if (segments[0] === 'prospect') segments.shift();
    if (segments.length !== 1) return null;
    let segment;
    try {
        segment = decodeURIComponent(segments[0]);
    } catch {
        return null;
    }
    const code = segment.replace(/[.,;:!?)\]}'"]+$/, '').toLowerCase();
    return CODE.test(code) ? code : null;
}

// The address to send, copy or open for a prospect page
export function prospectUrl(slug, { preview = false, branded = BRANDED_LINKS_LIVE, location = window.location } = {}) {
    const query = preview ? '?preview=true' : '';
    if (branded && CODE.test(slug || '')) {
        const origin = isLocal(location.hostname)
            ? `http://${LOCAL_BRANDED_HOST}${location.port ? `:${location.port}` : ''}`
            : `https://${BRANDED_HOST}`;
        return `${origin}/${slug}${query}`;
    }
    return `${location.origin}/prospect/${slug}${query}`;
}

// How the address reads in the editor's preview bar, without https:// ("…" until first saved)
const PLACEHOLDER_CODE = '0000000000';
export function prospectAddressLabel(slug, options) {
    const label = prospectUrl(slug || PLACEHOLDER_CODE, options).replace(/^https?:\/\//, '');
    return slug ? label : label.replace(PLACEHOLDER_CODE, '…');
}

// True when this page was opened from AppShell, e.g. the dashboard's Open button
export function openedFromAppShell(referrer = document.referrer) {
    try {
        return APPSHELL_ORIGINS.includes(new URL(referrer).origin);
    } catch {
        return false;
    }
}
